import baseRoute from '../baseRoute';

export default `${baseRoute}/contact` as const;
